var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.703 12.4829L16.3252 6.01562H13.2755V8.91967H11.9865V6.01562H7.0219V8.91967H5.73289V6.01562H2.6831L2.00573 17.6112C1.95301 18.5141 2.26572 19.3736 2.88629 20.0315C3.50686 20.6894 4.34669 21.0517 5.25106 21.0517H12.4012C11.984 20.2393 11.7484 19.3191 11.7484 18.3448C11.7484 15.4041 13.8948 12.9557 16.703 12.4829Z",
    fill: "#7F7F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02143 4.77125C7.02143 3.40254 8.13496 2.28901 9.50367 2.28901C10.8724 2.28901 11.986 3.40254 11.986 4.77125V6.0151H13.275V4.77125C13.275 2.69178 11.5832 1 9.50367 1C7.42416 1 5.73242 2.69178 5.73242 4.77125V6.0151H7.02143V4.77125Z",
    fill: "#7F7F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3486 18.3452C22.3486 15.778 20.2601 13.6895 17.6929 13.6895C15.1257 13.6895 13.0371 15.778 13.0371 18.3452C13.0371 20.9124 15.1257 23.0009 17.6929 23.0009C20.2601 23.0009 22.3486 20.9124 22.3486 18.3452ZM16.9958 20.6254L14.9023 18.2576L15.8679 17.4038L17.0374 18.7265L19.4594 16.2178L20.3867 17.113L16.9958 20.6254Z",
    fill: "#7F7F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyPurchase);
export default __webpack_public_path__ + "static/media/icon_my_purchase.2f6c295151c138a4073a8adb6f0cede5.svg";
export { ForwardRef as ReactComponent };